import { render, staticRenderFns } from "./titleHead.vue?vue&type=template&id=31ba02c2&"
import script from "./titleHead.vue?vue&type=script&lang=js&"
export * from "./titleHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports